import React from 'react';
import { View, ActivityIndicator, Platform } from 'react-native';
import { Image } from '@rneui/themed';
import PropTypes from 'prop-types';
import { SvgUri } from 'react-native-svg';

const Header = ({ topNav, height, width }) => {
    const logoCdnImagePath = topNav?.logo?.cdnImagePath;
    const imgExt = logoCdnImagePath.substring(logoCdnImagePath.length - 4, logoCdnImagePath.length);

    // TODO MAKE A STANDARD SVG COMPONENT FOR GLOBAL USE SEE IMAGEWITHDESCRIPTION
    // eslint-disable-next-line react/no-unstable-nested-components
    const SvgFallback = () => {
        return (
            <SvgUri
                uri='https://jhm-cms.images.sardius.media/media/12467/cs_logo_4color_horiz-01.svg' //NEED A FALLBACK LOGO URI
                height={75}
                width={125}
            />
        );
    };

    return (
        <View
            style={{
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#fff'
                // paddingTop: Constants.statusBarHeight,
                // paddingBottom: 15
            }}
        >
            {imgExt?.equals('.svg') && !Platform.OS.equals('web') && (
                <SvgUri
                    uri={`https:${logoCdnImagePath}`}
                    // height={logo.height}
                    // width={logo.width}
                    height={50}
                    width={'100%'}
                    fallback={<SvgFallback />}
                />
            )}
            {imgExt.equals('.svg') && Platform.OS.equals('web') && (
                <Image
                    resizeMode='center'
                    source={{ uri: `https:${logoCdnImagePath}` }}
                    // style={{height: height, width: width}}
                    height={150}
                    width={200}
                />
            )}
            {!imgExt.equals('.svg') && (
                <Image
                    resizeMode='center'
                    source={{ uri: `https:${logoCdnImagePath}` }}
                    style={{ height: height, width: width }}
                    alt={'Mobile Home screen Cornerstone Logo'}
                    PlaceholderContent={<ActivityIndicator />}
                />
            )}
        </View>
    );
};

Header.propTypes = {
    splashLogo: PropTypes.string,
    backgroundColor: PropTypes.string,
    headerBackgroundColor: PropTypes.string,
    logUrl: PropTypes.string
};
export default Header;
